module.exports = __webpack_public_path__ + "img/hero_en.b1d8589.jpg";